import { DataTable } from '@/components/Ui';
import { useEstablishments } from '../hooks';
import { Button } from '@/components/Common';
import EstablishmentDeletionModal from './modals/EstablishmentDesactiveModal';
import EstablishmentSendMailModal from './modals/EstablishmentSendMailModal';
import { EstablishmentDetail } from './EstablishmentDetail';
import { EstablishmentForm } from './EstablishmentForm';

export const EstablishmentsList = () => {
  const {
    columns,
    formattedData,
    establishmentListLimit,
    establishmentListPage,
    isLoading,
    establishments,
    handleAddEstablishment,
  } = useEstablishments();

  return (
    <div className="h-screen">
      {/* Modals */}
      <EstablishmentDeletionModal />
      <EstablishmentSendMailModal />
      <EstablishmentDetail />
      <EstablishmentForm />

      {/* Header */}
      <div className="flex justify-between items-center bg-[#232323] py-4 px-7 rounded-[8px]">
        <p className="text-white text-lg font-bold">Liste des établissements</p>
        <div className="flex items-center gap-4">
          <Button
            title="Nouvel établissement"
            className="h-[41px]"
            onClick={handleAddEstablishment}
          />
        </div>
      </div>

      {/* Table */}
      <DataTable
        columns={columns}
        value={formattedData}
        loading={isLoading}
        withPaginator={true}
        currentPage={establishmentListPage}
        currentPageHandler={() => {}}
        listlimit={establishmentListLimit}
        limitHandler={() => {}}
        countTotal={establishments?.length || 0}
      />
    </div>
  );
};
